import faqDataEn from "../faq/FAQDataEn";
import faqDataAUEn from "../faq/FAQDataAUEn";

export const English = {
  translation: {
    brandInfo: {
      botName: {
        lifesafer: "Lili",
        monitechiid: "Molly",
        guardianinterlock: "Gabby",
        quickstartaz: "Kelly",
      },
      brandName: {
        lifesafer: "LifeSafer",
        monitechiid: "Monitech",
        guardianinterlock: "Guardian Interlock",
        quickstartaz: "QuickStart",
      },
      brandPhone: {
        lifesafer: "(855) 221-0171", //special phone number for LS installations
        monitechiid: "(800) 521-4246",
        guardianinterlock: "(800) 499-0994",
        quickstartaz: "(888) 717-8278",
        AU: "1800-497-033",
      },
      brandPhoneHref: {
        lifesafer: "tel:+1-855-221-0171",
        monitechiid: "tel:+1-800-521-4246",
        guardianinterlock: "tel:+1-800-499-0994",
        quickstartaz: "tel:+1-888-717-8278",
        AU: "tel:+61-1800-497-033",
      },
    },
    policies: {
      termsofUseLabel: "Terms of Use",
      privacyLabel: "Privacy",
      cookiesLabel: "Cookies",
      qualityLabel: "Quality",
      copyrightLabel: "Copyright",
      callMonitech:
        "Unfortunately we aren't in this state, but good news our partner Monitech does service this state!! Please feel free to reach out to Monitech at (800) 521-4246.",
      countyQuestionable:
        "For this county we will need you to contact us so we can assist you with enrollment, (800) 634-3077.",
    },
    faqs: {
      header: "Frequently Asked Questions",
      button: "View FAQs",
      tipOfTheDay: "Tip of the Day",
      faqData: faqDataEn,
      faqDataAU: faqDataAUEn,
    },
    carousel: {
      name1: "Appointments",
      description1:
        "View, schedule, change, or cancel your service appointments conveniently and quickly.",
      name2: "Payments",
      description2:
        "View, set up, or change your preferred payment method easily and securely keeping you in control of your account.",
      name3: "Device Resources",
      description3:
        "Review, watch, and learn important information about your device so you can understand your journey with LifeSafer.",
    },
    registration: {
      sectionTitle: "Registration",
      personalInformationStep: "Personal Information",
      addressStep: "Address",
      passwordStep: "Password",
      verify: "Verify",
      continue: "Continue",
      createAccount: "Create Account",
      backToSignIn: "Back to Sign In",
      firstName: "Legal First Name",
      firstNameRequired: "First Name is required.",
      firstNameLengthError: "First name must be two letters or more.",
      lastName: "Legal Last Name",
      lastNameRequired: "Last Name is required.",
      lastNameLengthError: "Last name must be two letters or more.",
      cityRequired: "City is required.",
      cityMinLength: "Min Length is 2.",
      cityInvalid: "City is invalid.",
      emailAddress: "Email Address",
      emailRequired: "Email Address is required.",
      emailValid: "Email Address must be valid.",
      phoneType: "Phone Type",
      cellPhone: "Cell Phone",
      homePhone: "Home Phone",
      phoneNumber: "Phone Number",
      phoneNumberRequired: "Phone number is required",
      homePhoneRequired: "Home Phone is required.",
      phoneValid: "Valid phone number is required.",
      verifyPersonalInformation: "Verify",
      homeAddressLine1: "Address Line 1",
      poHomeAddressPlaceHolder: "Enter your PO Box",
      addressRequired: "Home Address is required.",
      addressDirections:
        "You will need to select an address from the autocomplete.  If your address isn't found, enter your city and state in Address Line 1 and select it from the autocomplete.",
      homeAddressLine2: "Address Line 2",
      homeAddressPlaceHolder: "Enter your home address.",
      homeCityCountyState: "City, County, State",
      homeCityCountyStatePlaceHolder: "This will be filled in for you!",
      homeCity: "City", // not required
      homeCounty: "County", // not required
      homeState: "State", // not required
      stateRequired:
        "State is required. Please enter a valid address or select one from the Address Line 1 dropdown list.",
      stateValid: "State must be valid.", // not required
      homeZip: "Zip",
      ausHomeZip: "Postal Code",
      zipRequired: "Zip Code is required.",
      ausZipRequired: "Postal Code is required.",
      zipValid: "A valid Zip Code must be 5 digits in length.",
      ausZipValid: "A valid Postal Code must be 4 digits in length.",
      continueFromAddress: "Continue",
      password: "Password",
      passwordRequired: "Password is required.",
      passwordPattern:
        "Password must be between 8 - 24 characters in length, contain at least 1 upper case letter, 1 lower case letter, 1 number, and 1 special character.",
      confirmPassword: "Confirm Password",
      confirmPasswordMatch: "The passwords must match.",
      confirmPasswordRequired: "Password Confirmation is required.",
      GoogleText1: "This site is protected by reCAPTCHA and the Google ",
      GoogleText2: " and ",
      GoogleText3: " apply.",
      GoogleLink1: "Privacy Policy",
      GoogleLink2: "Terms of Service",
      emailInUse: "Email already in use",
      emailInUseInstructions:
        "Please enter a different email or reset your password.",
      here: "Here",
      phoneNumberInUse: "Phone number already in use with different email.",
      continueToLogin: "To continue using ",
      returnToLogin: "Return to Login",
      verifyEmail: "To use the entered email please verify ",
      apiErrorTitle: "Error contacting server.",
      apiError:
        "An error occurred while trying to verify your information. Please try again.",
      registrationComplete: [
        "Registration Completed Successfully!",
        "You will be signed in automatically.",
        "If for some reason you are not please return to the Sign In page and log in.",
      ],
      verificationCode: "Verification Code",
      verificationCodeTitle: "Verify phone number",
      verificationCodeDescription:
        "The entered email already exists in our system with a different phone number. To continue using the entered email please verify your phone with the code we have sent via text message.",
      submitVerificationCode: "Submit Code",
      verificationCodeRequired: "Verification Code Required.",
      verificationCodeInvalid: "Verification Code Invalid",
      verificationCodeIncorrect:
        "Verification code was incorrect. Please double check and enter again.",
      verificationCodeExpired: "Verification code expired.",
      dateOfBirth: "Date of Birth",
      dateOfBirthRequired: "Date of Birth Required.",
      dateOfBirthInvalid: "Valid Date of Birth is Required.",
      resetPassword: "Reset Password",
      changeEmail: "Change Email",
      contactUs: "Contact Us",
      contactUsMessage:
        "We do not have a cell phone on record for you. Please call us at (800) 634-3077",
      emailUpdateError: "Error updating email.",
      city: "City",
      client: "Client",
      unAuthorized: "Unauthorized",
      takePhoto: "Take Photo",
      uploadPhoto: "Upload Photo",
      identityVerification: "Identity Verification",
      instructions: "Instructions",
      chooseFile: "Choose File",
      retake: "Retake",
      upload: "Upload",
      newFile: "New File",
      badPhotoFile: "Bad Photo File",
      uploadComplete:"Upload Complete",
      uploadCompleteMessage:"Thank you for uploading your State ID which will help ensure accuracy in reporting your data.",
      takePhotoDesp: "When taking the picture please ensure the ID is as centered as possible. When you're ready click the button below to activate your camera, you may need to allow us this access (popup should appear).",
      uploadPhotoDesp: "When taking the picture please ensure the ID is as centered as possible. Then click the upload button and pick your image. Accepted formats: png, jpg, jpeg, heic.",
      uploadMessage: "Note: To ensure your photo is high enough quality for the ID Upload to work please use your mobile device.",
      unAuthorizedMsg: "This link has either expired or isn't available for use. If you believe you have reached this message in error please feel free to contact us.",
      honeyPotError: "Something went wrong, please contact us to assist you",
      autoPayEnrollment: "Auto Pay Enrollment",
      autoPayments:"Auto Payments",
      autoPaymentThankYou : "Thank you for signing up for Auto Payments, log into your My Account to update if needed.",
      secureSign:"Secure Sign",
      documentSign : "Document Sign",
      signNowThankYou: "Thank you for signing your documents, log into your My Account to view any of these signed documents.",
    },
    account: {
      headerSlogan: "We are committed to your success",
      email: "Email Address",
      emailRequired: "Email is required.",
      emailValid: "Invalid email address.",
      password: "Password",
      passwordRequired: "Password is required.",
      passwordForgot: "Forgot Password?",
      signInButton: "Sign In",
      resetPasswordMessage:
        "Once you click the Reset Password button you will then be sent a password reset link to this email address. Please go to your email to complete the final step of the reset.",
      resetPasswordButton: "Next",
      backToSignInButton: "Back to Sign In",
      resetPasswordSent:
        "A password reset link has been sent to this email address. Please go to your email to complete the final step of the reset.",
      resetPasswordSuccess:
        "Please check your email for password reset instructions",
      resetPasswordError:
        "Reset failed, this email is not registered or not confirmed with LifeSafer.",
      resetPhoneError:
        "Reset failed, this phone is not registered or not confirmed with LifeSafer.",
      passwordPattern:
        "Password must be between 8 - 24 characters in length, contain at least 1 upper case letter, 1 lower case letter, 1 number, and 1 special character.",
      confirmPassword: "Confirm Password",
      confirmPasswordRequired: "Password Confirmation is required.",
      confirmPasswordValid: "The passwords must match.",
      resetCode: "Reset Code",
      resetCodeRequired: "Reset Code is required.",
      resetCodeInputInvalid: "Invalid reset code.",
      resetCodeSent:
        "Your reset code has been sent it will expire in 10 minutes",
      resetCodeInvalid: "Invalid reset code, please enter the code again.",
      resetCodeExpired: "Reset code has expired.",
      resetCodeError: "Reset code failed.",
      tokenFailedPart1:
        "Token validation failed, if the token has expired you can get a new one at the ",
      tokenFailedPart2: "forgot password",
      tokenFailedPart3: " page.",
      tokenValidation: "Validating token...",
      verifyHeader: "Verify Email",
      verificationFailedPart1:
        "Verification failed, you can also verify your account using the ",
      verificationSuccess: "Verification successful, you can now login",
      tokenVerification: "Verifying...",
      registrationSuccess:
        "Registration successful, please check your email for verification instructions.",
      registrationFail:
        "Registration failed, this email is already registered.",
      passwordResetSuccess: "Password reset successful, you can now login.",
      receiveText: "Receive a reset text message",
      receiveEmail: "Receive a reset email",
      idUpload: "ID Upload",
      phoneEmail: "Cell Phone Number or Email",
      phoneEmailRequired: "Cell Phone Number or Email Required.",
      phoneValid: "Invalid Phone Number",
      secureIdUpload: "Secure ID Upload",
      providerChgMessage: "Depending on your provider, text charges may apply.",
    },
    navigation: {
      dashboard: "Dashboard",
      appointments: "Appointments",
      payments: "Payments",
      documents: "Documents",
      resources: "Resources",
      help: "Help",
      logOut: "Log Out",
      language: "Language",
      notifications: "Notifications",
      profile: "Profile",
    },
    buttons: {
      updateButton: "Update",
      nextButton: "Next",
      deleteButton: "Delete",
      createButton: "Create",
      cancelButton: "Cancel",
      closeButton: "Close",
      saveButton: "Save",
    },
    toasts: {
      updateComplete: "Update complete.",
      updateFailed: "Update failed.",
      deleteNotification: "Notification deleted.",
      messageDeleted: "Message deleted.",
      messageUpdated: "Message updated.",
      messageCreated: "Message created.",
      error: "An Error has occurred!",
      uploadComplete: "Upload complete.",
      uploadFailed: "Upload failed.",
      saving: "Saving.",
    },
    home: {
      upcomingAppointments: "Upcoming Appointments",
      noAppointments: "You currently don't have any upcoming appointments.",
      scheduleButton: "Schedule",
      upcomingPayments: "Upcoming Payments",
      paymentPastDue: "Payment Past Due",
      paymentAttentionNeeded: "Attention Needed",
      noPayments: "You currently don't have any upcoming payments.",
      paymentsSignUp:
        "You aren't currently signed up for auto payments. Save time and enroll today.",
      signUpButton: "Sign Up Now!",
      saveTime: "Save Time, Enroll in AutoPay:",
      noNotifications: "You currently don't have any notifications.",
      deviceInfo: "Device Information",
      noDevice: "You currently don't have a LifeSafer device.",
      IID: "Ignition Interlock",
      PAM: "Portable Alcohol Monitor",
      serviceLocation: "Service Location:",
      directions: "Directions",
      paymentMethod: "Payment Method:",
      autoPay: "AutoPay:",
      autoPayProcessDate:
        "Your auto payment will process on the date shown above.",
      endingIn: "Ending In:",
      paymentQuote:
        "The amount quoted above is an estimate of your past due balance and a purchase of an additional 14 days.",
      FC100UserGuide:
        "https://www.lifesafer.com/wp-content/uploads/2020/05/2031159-2_A1_BK-LS439-FC100-Camera-Handbook-Master.pdf",
      L250UserGuide:
        "https://www.lifesafer.com/wp-content/uploads/L250-Client-User-Guide.pdf",
      PAMUserGuide:
        "https://s33035.pcdn.co/wp-content/uploads/2020/02/LS681.PAM-English-User-Guide.pdf",
      userGuide: "User Guide",
      tipsAndCare: "Tips & Care",
      training: "Training",
      troubleshooting: "Troubleshooting",
      yesButton: "Yes",
      frequentlyAskedQuestions: "FAQs",
    },
    notifications: {
      typeHeader: "Type",
      messageHeader: "Message",
      dateHeader: "Date",
      deleteButton: "Delete",
      deleteToast: "Notification deleted.",
      updateFailed: "Update failed.",
      messageTooltip: "Unread",
      deleteTooltip: "Delete Notification",
      dashboardButton: "Dashboard",
    },
    profile: {
      personal: "Personal",
      information: " Information",
      personalFull: "Personal Information",
      state: "State",
      court: "Court",
      vehicle: "Vehicle",
      name: "Name",
      email: "Email",
      password: "Password",
      lastChanged: "Last Changed: ",
      phone: "Phone",
      cell: "Cell",
      home: "Home",
      emergencyContact: "Emergency Contact",
      preferences: "Preferences",
      contactByText: "Contact By Text",
      contactByEmail: "Contact By Email",
      defaultLanguage: "Language",
      update: "Update",
      firstName: "Legal First Name",
      lastName: "Legal Last Name",
      firstNameRequired: "First Name is required.",
      lastNameRequired: "Last Name is required.",
      currentEmail: "Current Email",
      newEmail: "New Email",
      confirmEmail: "Confirm New Email",
      emailWarning:
        "* Please note by updating your email this will change your login email.",
      newEmailRequired: "New email is required.",
      emailInvalid: "Invalid email address.",
      confirmEmailRequired: "Confirm new email is required.",
      matchEmail: "The email addresses must match.",
      confirmPassword: "Confirm Password",
      passwordWarning:
        "* Your password must be a minimum of 8 characters and contain at least 1 upper case letter, 1 lower case letter, 1 number, and 1 special character.",
      textMessageWarning:
        "Disabling text messages will make it more difficult to log in or reset your password to your My Account site!",
      passwordRequired: "Password is required.",
      passwordValid:
        "Password must be between 8 - 24 characters in length, contain at least 1 upper case letter, 1 lower case letter, 1 number, and 1 special character.",
      confirmPasswordRequired: "Password Confirmation is required.",
      matchPassword: "The password must match.",
      cellPhone: "Cell Phone",
      homePhone: "Home Phone",
      homePhoneRequired: "Home Phone is required.",
      phoneValid: "Valid phone number is required.",
      eContactFirstName: "Emergency Contact First Name",
      eContactLastName: "Emergency Contact Last Name",
      eContactPhone: "Emergency Contact Phone",
      eContactFirstNameReq: "Emergency Contact First Name is required.",
      eContactLastNameReq: "Emergency Contact Last Name is required.",
      eContactPhoneReq: "Phone number is required.",
      eContactPhoneValid: "Valid phone number is required.",
      mayWeText: "May we contact you by Text Message?",
      mayWeEmail: "May we contact you by Email?",
      languageSelect: "Select a Language",
      languagePrefReq: "Language Preference is required.",
      dob: "Birthday",
      country: "Country",
      address: "Address",
      stateID: "State ID",
      dobLabel: "Date of Birth",
      addrLine1: "Address Line 1",
      addrLine2: "Address Line 2",
      city: "City",
      stateSelect: "Select a State",
      addrLine1Required: "Home Address is required.",
      cityRequired: "City is required.",
      stateRequired: "State is required.",
      zip: "Zip",
      zipRequired: "Zip Code is required.",
      zipValid: "A valid Zip Code must be 5 digits in length.",
      zipInvalid: "Zip is Invalid",
      ausZip: "Postal Code",
      ausZipRequired: "Postal Code is required.",
      ausZipValid: "A valid Postal Code must be 4 digits in length.",
      IDNumber: "Identification Number",
      expDate: "Expiration Date",
      expDateRequired: "Expiration date is required.",
      countryRequired: "Country is required.",
      IDNumberRequired: "Identification number is required.",
      conviction: "Conviction",
      courtContact: "Court Contact",
      contactEmail: "Contact Email",
      LSDevice: "LifeSafer Device",
      countySelect: "Select County",
      VIN: "VIN",
      licensePlate: "License Plate",
      pushStart: "Push Button Start",
      remoteStart: "Remote Start",
      currentVIN: "Current VIN",
      newVIN: "New VIN",
      confirmVIN: "Confirm VIN",
      VINMessagePart1: "* VIN - Vehicle Identification Number",
      VINMessagePart2:
        "A 16 or 17 character identity code that is made of numbers and letters that identifies your vehicle.",
      VINRequired: "VIN is required.",
      VINValid: "VIN must be 16 or 17 characters in length.",
      VINConfirmRequired: "VIN Confirmation is required.",
      VINMatch: "The VINs must match.",
      vehicleConfirm: "Vehicle Confirmation",
      year: "Year: ",
      make: "\nMake: ",
      model: "\nModel: ",
      VINError: "VIN verification was invalid, please retry.",
      currentLP: "Current License Plate: ",
      manualUpdate: "Manual Update",
      newLP: "New License Plate Number",
      confirmLP: "Confirm License Plate Number",
      licensePlateRequired: "License Plate number is required.",
      confirmLPRequired: "Confirm new license plate number is required.",
      licensePlateMatch: "The license plate numbers must match.",
      havePushStart: "Does this vehicle have push start ignition?",
      pushStartMessage:
        "Push start ignition is a keyless button that allows you to start your vehicle while inside the vehicle typically with the brake pedal depressed.",
      haveRemoteStart: "Does this vehicle have remote start ignition?",
      remoteStartMessage:
        "Remote start ignition is a key fob that has a button that allows you to start your vehicle while outside the vehicle by pressing this key fob.",
      updateComplete: "Update complete.",
      passwordUpdateSuccess: "Password update successful.",
      updatePreferencesError: "Cannot update preferences.",
      contactUs:
        "There is a problem updating your profile please contact us so we can assist you.",
        dobRequired:'Date of birth is required.',
      dobUnderage: "Date of Birth Invalid. You must be more than 18.",
      dobInvalid: "Date of Birth is Invalid",
      lName: "Last Name",
    },
    appointments: {
      appointment: "Appointment",
      scheduleApptButton: "Schedule Appointment",
      scheduleInstButton: "Schedule Installation",
      nextDayMessage:
        "Currently we aren't scheduling same or next day appointments online. If you need a same or next day appointment please",
      within24Message:
        "You are attempting to change an appointment within 24 hours of the appointment, please contact us so we can help you with this request.",
      within4Message:
        "You are attempting to change an appointment within 4 hours of the appointment, please contact us so we can help you with this request.",
      cantChangeMessage:
        "You are attempting to change an installation appointment, please contact us so we can help you with this request.",
      undefinedApptMessage:
        "This appointment cannot be rescheduled from this portal, please contact us so we can help you with this request.",
      reschedule: "Reschedule",
      cancel: "Cancel",
      rescheduleMessage:
        "Keep in compliance, reschedule your appointment online today.",
      contactUsMessage:
        "Let our knowledgeable support team assist you with this appointment.",
      cancelMessagePart1: "Cancel your scheduled appointment.",
      cancelMessagePart2:
        "Cancelling appointments can put you at risk of a compliance violation.",
      keep: "Keep",
      cancelWarning:
        "Please note that cancelling will release this date and time for this location. We can't guarantee this date and time would be available at this location if you did want to reschedule.",
      deviceSelect: "Please Select A Device",
      vehicleSelect: "Please Select A Vehicle",
      lockoutAlertPart1:
        "Attention: Please be aware that it is your responsibility to be serviced prior to your lockout date, your current lockout date is",
      lockoutAlertPart2:
        "If you have any questions, please contact LifeSafer at",
      apptLocContactUsMessage:
        "Please contact us directly to schedule an appointment at this location.",
      apptDeinstallContactUsMessage:
        "Please contact us directly to schedule a Deinstallation Appointment to ensure all state regulations are followed.",
      deinstall: "Deinstall",
      personalInfo: "Personal Information",
      location: "Location",
      service: "Service",
      enterTextBox: "Enter ZIP Code or City, State",
      search: "Search...",
      noLocations: "No locations in the selected area.",
      searchResults: "Search Results",
      select: "Select",
      pastDueService:
        "Your service is past due, let's get you assistance from our 24/7 expert support!",
      almostPastDueService:
        "You need an immediate service to avoid being past due, let's get you assistance from our 24/7 expert support!",
      selectedLocation: "Selected Location",
      selectedService: "Selected Service",
      noAppointmentsAvail:
        "There are currently no available appointments for this location.",
      noTimesAvail:
        "No available appointment times at this location for this date.",
      backToCalendar: "Back to Calendar",
      aptSchedPart1: "You have selected to ",
      aptSchedPart2: " reschedule \n an ",
      aptSchedPart2Alt: "make a \n new ",
      aptSchedPart3: "appointment on: \n",
      aptSchedPart4: " at ",
      aptSchedPart5: "\n for a ",
      aptSchedPart6: " Service \n ",
      aptSchedPart7: "at the following location: \n",
      originalAppt: "Original Appointment Date/Time",
      date: "Date",
      time: "Time",
      cancelSuccess: "Appointment cancelled.",
      cancelFail: "Cancellation failed.",
      apptSaveSuccess: "Appointment saved.",
      apptUpdateSuccess: "Appointment updated.",
      mapInfo: "Map Information",
      sameDayLoc: "Same Day Location",
      standardLoc: "Standard Location",
      installStep1: "What is the enrollment code given to you?",
      installCodeInputLabel: "Enrollment Code",
      installCodeInputRequired: "Enrollment Code is required.",
      installCodeInputInvalid: "Invalid enrollment code.",
      installNoCode: "Don't have an enrollment code? Click ",
      installStateLabel: "State",
      installStatePlaceholder: "Select a State",
      stateRequired: "State is required.",
      cantFindState:
        "Not finding the state your looking for? Please contact our support team to get you in touch with one of our partners that does service your state. Call or Click the button below.",
      installCountyLabel: "County",
      installCountyPlaceholder: "Select a County",
      countyRequired: "County is required.",
      installNotAvailable: [
        "Unfortunately ",
        " doesn't service this state at this time. Please feel free to give us a call if you have questions, ",
        ".",
      ],
      installStep2: [
        "Please, enter in which state you were convicted or are volunteering to have a ",
        " device.",
      ],
      IIDButtonLabel: "Ignition Interlock Device",
      PAMButtonLabel: "Portable Alcohol Monitor",
      installStep3Part1: "What type of device do you need? Click ",
      installStep3Part2:
        " for some quick information if you don't know which device you require.",
      installStep3ButtonLabel: "here",
      devicePopupTitle: " Device Information",
      devicePopupButtonLabel: "Close",
      devicePopupPart1:
        "A small handheld car breathalyzer device that measures the amount of alcohol in the user’s breath. Installing one is a common requirement following a drunk driving offense (DUI, DWI, DUI, OWI, or OVI).",
      devicePopupPart2:
        "A small, portable handheld breathalyzer device that measures the amount of alcohol in the user’s breath. Commonly issued to monitor a user while at home.",
      IDStateLabel: "ID issuing state",
      IDNumberLabel: "Identification Number",
      IdExpDateLabel: "Expiration Date",
      IdExpDateRequired: "Expiration Date Required",
      IDInfoTitle: "State ID Information",
      vehInfoTitle: "Vehicle Information",
      multiVehicleNew: "New Vehicle",
      vehYearLabel: "Vehicle Year",
      vehYearPlaceholder: "Select a Year",
      vehYearRequired: "Vehicle Year is required.",
      vehMakeLabel: "Vehicle Make",
      vehMakePlaceholder: "Select a Make",
      vehMakeRequired: "Vehicle Make is required.",
      vehModelLabel: "Vehicle Model",
      vehModelPlaceholder: "Select a Model",
      vehModelRequired: "Vehicle Model is required.",
      VINYearLabel: "Year: ",
      VINMakeLabel: "\nMake: ",
      VINModelLabel: "\nModel: ",
      licPlateIssue:
        "Hmm, something went wrong in my wiring, please input your vehicle's license plate number and issuing state one more time for me! If you don't have it click the red skip button.",
      licPlateLabel: "License Plate Number",
      licPlateRequired: "License Plate number is required.",
      vehSaveError: "Vehicle not saved",
      adminButtonLabel: "Administrative",
      courtButtonLabel: "Court Order",
      voluntaryButtonLabel: "Voluntary",
      preTrialButtonLabel: "Pre-Trial",
      probationButtonLabel: "Probation",
      VINInfoLinkPart1: "Click ",
      VINInfoLinkPart2:
        " for some quick information about your Vehicle Identification Number (VIN).",
      VINInfoLink: "here",
      ProgTypeInfoLinkPart2: " for some quick information about Program Types.",
      programTypeIssue:
        "Hmm, something went wrong in my wiring, please select your program type one more time for me!",
      ProgTypeInfoTitle: "Program Type Information",
      DeviceLengthQuestion: "How long will you need your device?",
      DeviceLengthMonths: "Months",
      DeviceLengthError: "You must choose a number between 3 and 24",
      AdminDescription:
        "This type of program is typically assigned by the Motor Vehicle Administration.",
      CourtOrderDescription:
        "The court has ordered you to have a device installed.",
      VoluntaryDescription:
        "Volunteering to have a device installed is a great way to protect yourself and others.",
      PreTrialDescription:
        "This type of program typically means you may not have gone to court or been sentenced yet.",
      ProbationDescription:
        "The court has ordered you to have a device installed because you have been sentenced in 1 or more previous cases.",
      closePopUp: "Close",
      lossProtectionQuestion:
        "Would you like to include a loss protection plan for your device?",
      lossProtectionInfoLinkPart2:
        " for some quick information about the Loss Protection Plan.",
      lossProtectionInfoTitle: "Loss Protection Plan Information",
      lossProtectionInfoPart1: [
        "", //leave here because of the Spanish translation and how the phare is constructed for it.
        " monitoring devices aren't cheap and we wouldn't want to see you get stuck with the bill if something should happen. The ",
        " Loss Protection Plan avoids this necessary risk of not having protection against the occasionally mishap, we strongly encourage your to protect your device!",
      ],
      lossProtection: "Loss Protection",
      noProtection: "No Protection",
      lossProtectionIssue:
        "Hmm, something went wrong in my wiring, please select your loss protection one more time for me!",
    },
    payments: {
      accountInfo: "Account Information",
      makePayment: "Make a Payment",
      paymentMethods: "Payment Methods",
      accountBalance: "Account Balance",
      accountHistory: "Account History",
      makePaymentButton: "Make A Payment",
      acctBalMessage1: "Please Wait",
      acctBalMessage2: "Balance available shortly...",
      dateHeader: "Date",
      descHeader: "Description",
      amountHeader: "Amount",
      invoiceHeader: "Invoice",
      balanceHeader: "Balance",
      transHistory: "Transaction History",
      newCardButton: "Add New Card",
      noAutoPayMessage: "Currently your account isn't set up for auto pay.",
      cardRejectedMessage:
        "This card has been rejected. Please edit or delete.",
      autoPay: "Auto Pay",
      autoPayMessage:
        "By checking this box, you are authorizing us to charge this card pursuant to the Terms and Conditions of your Program Service Agreement.",
      billingCycleLabel: "Auto Pay Billing Cycle",
      weekly: "Weekly",
      biweekly: "BiWeekly",
      monthly: "Monthly",
      editButton: "Edit",
      deleteButton: "Delete",
      deleteMessage: "Are you sure you want to delete this payment method?",
      acceptedPayMethods: "Accepted Payment Methods",
      paymentMethod: "Payment Method",
      redoMessage: "You will need to revalidate card information.",
      zipCode: "Zip Code",
      cardNumber: "Card Number",
      expDate: "Expiration Date",
      autoPaySignUpMessage:
        "By submitting your credit or debit card information on this page and checking this box, you are authorizing us to charge this card pursuant to the Terms and Conditions of your Program Service Agreement.",
      autoPayEnroll: "Enroll in Auto Pay",
      zipCodeError: "Invalid Zip Code, please correct.",
      cardNumberError: "Invalid Card Number, please retry.",
      cvv2Error: "Invalid CVV2, please correct.",
      expDateError: "Invalid Expiration Date, please correct.",
      verifyButton: "Verify",
      confirmation: "Confirmation",
      selectPaymentMethod: "Please Select Payment Method",
      selectPaymentAmount: "Please Select Payment Amount",
      otherAmount: "Other Amount",
      submitButton: "Submit",
      confirmMessagePart1: "You have selected to make a \n payment on: \n",
      confirmMessagePart2: "\n in the amount of: \n $ ",
      confirmAlert:
        "Refreshing the page during processing can cause balance inaccuracy and duplicate payments.",
      invoiceDownloading: "Invoice downloading...",
      invoiceDownloaded: "Invoice downloaded",
      invoiceDownloadFailed: "Invoice failed to load",
      noCCPaymentOption:
        "Credit card payment option is not set up for your location.",
      noCCOnFile: "No active cards on file.",
      ccDeleted: "Payment method deleted.",
      paymentReceived: "Payment received.",
      paymentFailed: "Payment failed.",
      ccVerificationError: "There was a problem verifying this payment method.",
      ccNotSupported:
        "Your current location does not support online credit card payments. Please call us at (800) 634-3077",
      ccPaidToDateInPastPart1:
        "To enable Auto Pay we need you to pay your current account balance, click ",
      ccPaidToDateInPastPart2:
        "to make your payment. If you have any questions or need assistance, please feel free to ",
      addAPaymentMethod:
        "Please add a payment method to make a payment online.",
      add: "Add",
      have2devices:
        "You currently have 2 devices for this vehicle, one needs to be returned to process a payment. Need Assistance?",
      goBack: "Back",
      information: "Information",
      appointmentType: "Appointment Type",
      appointmentTypeDescription: "Appointment Type Description",
      calibration: "Calibration",
      violationReset: "Violation Reset",
      select: "Select",
      vehicle: "Vehicle",
      days: "Days",
      shippingAddress: "Shipping Address",
      verify: "VERIFY",
      shipping: "Shipping",
      standardShipping: "Standard Shipping",
      expedientShipping: "Expedient Shipping",
      cancel: "Cancel",
      paymentSummary: "Payment Summary",
      makePaymentInPayment: "MAKE PAYMENT",
      thankyouPayment: "Thank You for your Payment.",
      failurePayment: "Payment Failure, please try again.",
      contactMessage: "When the total balance due is below $0 our online payment option is not available. Please contact our Customer Support team to assist you with this payment, (800) 634-3077.",
      earlyServiceFee:
        "Early Service Fee of $10 will be applied to this payment",
      appointmentDefinition: "Appointment Definition",
      apptDescCalibration:
        "If only your service light has just come on (comes on 10 days before you are due) it's time to make another 30 or 60 day payment.",
      apptDescLockOut1:
        "If your service and lockout lights have come on at the same time you are in early recall and your device needs to be reset.",
      apptDescLockOut2: "Note: ",
      apptDescLockOut3:
        "Your device will lock out 5 days after these lights started flashing.",
      quantity: "Quantity",
      item: "Item",
      unitPrice: "Unit Price",
      amount: "Amount",
      freeShips: "Free, ships in 2-3 business days",
      nextShips: [
        "$25.00, Device will be ",
        "shipped",
        " the following business day.",
      ],
      boxOverride: "PO Box Override",
      calculatingPayment: "Calculating Payment, Please Do NOT Refresh",
      processingPayment: "Processing Payment, Please Do NOT Refresh",
      taxableAmount: "Taxable Amount",
      tax: "Tax",
      nonTaxableAmount: "Non-Taxable Amount",
      totalNewCharges: "Total New Charges",
      priorAccountBalance: "Prior Account Balance",
      totalAmountDueNow: "Total Amount Due Now",
      due: "Due",
      now: "Now",
    },
    documents: {
      ToDO: "To Do",
      Completed: "Completed",
      formHeader: "Form",
      infoHeader: "Info",
      actionHeader: "Action",
      viewHeader: "View",
      review: "Review",
      upload: "Upload",
      template: "Form",
      warning:
        "The Sign and Submit button will become active when you reach the last page of the document.",
      signAndSubmit: "Sign and Submit",
      signAndSubmitSM: "Sign and\nSubmit",
      reviewed: "Reviewed",
      warningNonSignature:
        "The Reviewed button will become active when you reach the last page of the document.",
      signatureTitle: "Adopt Your Signature",
      adoptSignature: "Adopt Signature",
      cancel: "Cancel",
      legalName: "Legal First and Last Name",
      update: "Update",
      agreementPartI:
        "By selecting a signature and clicking the 'Adopt Signature' button you are agreeing to and signing the ",
      esa: "Electronic Signature Agreement.",
      agreementPartII:
        " Please take the time to read this document prior to continuing.",
      signature: "Signature",
      initials: "Initials",
      userSignatureSaveSuccess: "User signature saved",
      saveCompletedReportSuccess: "Completed report saved",
      documentDownloading: "Downloading document",
      documentDownloadFailed: "Failed to download document",
      documentDownloadSuccess: "Document downloaded",
      documentUploadSuccess: "Document uploaded",
      documentUploadFailed: "Document upload failed",
      documentUploadDataError: "Wrong data file",
      documentUploadErrorUploadType: "Missing Upload Type",
      documentUploadErrorFileType: "File Type not Supported",
      documentUploadErrorFileSize: "Max File Size of 10MB Exceeded",
      loadDocumentFailed: "Document load failed",
      instructions: "Instructions",
      photoInstructions:
        "When taking the picture please ensure the document is as centered as possbile. When you're ready click the button below to activate your camera, you may need to allow us this access (popup should appear).",
      computerCamInfo:
        "Note: Many built in laptop webcams may not yield a high enough quality picture for this upload process.",
      fileInstructions:
        "When taking the picture please ensure the document is as centered as possbile. Then click the upload button and pick your image. Accepted formats: .png, .jpg, .jpeg, .heic, .pdf",
      retake: "Retake",
      photoUpload: "Take Photo",
      fileUpload: "Upload File",
      chooseFile: "Choose File",
      newFile: "Choose Another File",
      goBack: "Back",
      badPhotoFile: "Bad Photo File",
      uploadNow: "Upload Now",
      documentExample: "Example",
      signDocumentFail: "Sign document failed",
      save: "Save",
      saving: "Saving",
      saved: "Saved",
      saveError: "Error saving",
      formNotValid: "Please fill all required form fields.",
      invalidSSN: "Please enter valid 4 digit SSN.",
      appointment: "Appt",
      declineModalHeader: "Information",
      declineModalBody:
        "Signing documents electronically allows for a faster installation saving your time. Are you sure you don’t want to sign electronically?",
      showHelpText: "Questions? Click ",
      showHelpLinkText: "Here",
      signButton: "Sign",
      declineButton: "Decline",
      noDocuments: "No Documents Available",
      permissionDenied: "Please allow access to your camera.",
      form: "Form",
      vehicle: "Vehicle",
      viewExample:
        "The example will open in a new tab momentarily. You may need to allow pop-ups for this site.",
        bookingInstallation : "Thank you for booking your installation, now let’s talk about the next steps to your success!",
      modalMessage1:"You will receive a text message from your {{brand}} White Glove specialist who can talk to you about your installation, discounts, and answer any other questions you may have. You can text or call us using that dedicated number.",
      modalMessage2:"Upon closing this pop up we will redirect you to the Documents section to get your quick to review, easy to sign pre-installation paperwork wrapped up and have you enter any required compliance information.",
      whiteGloveMessage:"Our White Glove Team is dedicated to your success, guiding you through the Pre-Installation process and they’re ready to help, get in touch now."
    },
    resources: {
      generalInfoHeader: "General Information",
      installCard: "Installation Information",
      installDesc:
        "Know what to expect at your interlock installation appointment.",
      installURL: "https://www.youtube.com/watch?v=dfMV64_RGx8",
      dosAndDontsCard: "Test Do's and Dont's",
      dosAndDontsDesc:
        "Understand the Do's and Don'ts of taking a alcohol breath test on your device.",
      dosAndDontsURL: "https://www.youtube.com/watch?v=fLVWcTyOi9A&t=10s",
      foodWarningCard: "Food Warning",
      foodWarningDesc:
        "There are some foods to avoid before taking a test, watch and learn how they can affect you.",
      foodWarningURL: "https://www.youtube.com/watch?v=VZg9lDAMLfU",
      deviceInfoHeader: "Device Information",
      L250TrainingCard: "L250 Training",
      L250TrainingDesc:
        "Learn about, how to use, and care for your L250 Ignition Interlock Device with this video training.",
      L250TrainingURL: "https://www.youtube.com/watch?v=SU_RHzfxkRc&t=5s",
      L250WarmUpCard: "L250 Warm Up Times",
      L250WarmUpDesc:
        "Learn about how to set up warm up times for your L250 Interlock to save time in cold weather.",
      L250WarmUpURL: "https://www.youtube.com/watch?v=mj4H6D5SYmw",
      FC100TrainingCard: "FC100 Training",
      FC100TrainingDesc:
        "Learn about, how to use, and care for your FC100 Ignition Interlock Device with this video training.",
      FC100TrainingURL: "https://www.youtube.com/watch?v=biubuR6AJU8",
      FI100TrainingCard: "FI100 Training",
      FI100TrainingDesc:
        "Learn about, how to use, and care for your FI100 Ignition Interlock Device with this video training.",
      FI100TrainingURL: "https://www.youtube.com/watch?v=biubuR6AJU8",
      PAMTrainingCard: "PAM Training",
      PAMTrainingDesc:
        "Learn about, how to use, and care for your Portable Alcohol Monitor with this video training.",
      PAMTrainingURL: "https://www.youtube.com/watch?v=KVQUId66ZOs",
    },
    help: {
      contactUs: "Contact Us",
      contactUsMessage:
        ", let's get you assistance from our 24/7 expert support team!",
      contactUsCallClick: "Call or Click",
      emailUs: "Email Us",
      emailUsMessage: "Have you found an issue or error within our site?",
      chatTitle: "Help",
      chatMessage:
        "Need help with your account and can't find it in the the portal?",
      chatSubMessage: "Chat with an agent.",
      chatButton: "Chat now",
      callUsButton: "Call Us ",
      lockout:
        "This appointment cannot be rescheduled from this portal, please contact us so we can help you with this request.",
    },
    securepay: {
      title: "Secure Pay",
      unauthorized: "Unauthorized",
      securepayLinkdesc: [
        "The Secure Pay link has either expired or isn't available for use. If you believe you've reached this message in error",
        "please feel free to contact us.",
      ],
      sessionTimer: "Session Timer: ",
      client: "Client: ",
      amountDue: "Amount Due: ",
      makePayment: "MAKE PAYMENT",
      agree: "Agree",
      paymentMethod: "Payment Method",
      payMessage:
        "By submitting your credit or debit card information on this page and checking this box, you are authorizing us to charge this card pursuant to the LifeSafer Terms of Use Policy.",
      paymentFailure: "Payment Failure, please try again.",
      securePaymentSaveFailure: "Secure Payment Save Failure: ",
      errorWithCreditCard: "Error with Credit Card Payment Save, ID: ",
      thankYou: "Thank You!",
      thankYouAfterPayment: [
        "The payment has been processed successfully for ",
        "You should receive a text message with your receipt shortly if not please feel free to contact us at (800) 634-3077",
      ],
      successPayment:
        "Payment Success. You should receive a text message with your receipt shortly.",
    },
  },
};
